/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RedeemRequestBody = {
  /**
   * The opaque one-time code issued by authorize.
   */
  code: string;
  /**
   * The PKCE code verifier whose base64url(sha256(...)) equals the stored code_challenge.
   */
  codeVerifier: string;
};

/** @internal */
export type RedeemRequestBody$Outbound = {
  code: string;
  code_verifier: string;
};

/** @internal */
export const RedeemRequestBody$outboundSchema: z.ZodMiniType<
  RedeemRequestBody$Outbound,
  RedeemRequestBody
> = z.pipe(
  z.object({
    code: z.string(),
    codeVerifier: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      codeVerifier: "code_verifier",
    });
  }),
);

export function redeemRequestBodyToJSON(
  redeemRequestBody: RedeemRequestBody,
): string {
  return JSON.stringify(
    RedeemRequestBody$outboundSchema.parse(redeemRequestBody),
  );
}
